<ion-segment
  mode="ios"
  [value]="selected"
  [scrollable]="true"
  class="category-segment"
  [ngClass]="{ 'scroll-segment': isDesktop }"
>
  <ng-container *ngFor="let cat of categorias; trackBy: trackByCats">
    <ion-segment-button [value]="cat" layout="icon-start" class="category-button" (click)="onCategoryClick(cat.ID_Categoria_GETM)">
      <ion-thumbnail class="category-image-container">
        <ion-img [src]="cat.Imagen"></ion-img>
      </ion-thumbnail>

      <ion-label class="category-label mpe-ellipsis-two">
        {{ cat.Categoria_GETM }}
      </ion-label>
    </ion-segment-button>
  </ng-container>
</ion-segment>
